<template lang="pug">
component.field(
  v-if="component"
  :is="component"
  v-bind="$attrs"
  v-on="$listeners"
)
</template>

<script>
const PersonConcern__FIELDS = new Set([
  "learning_style","strengths_and_weaknesses","eating","behavioral","social",
  "academic","physical_limitations","serious_illnesses","medical_conditions",
  "accidents","asthma","allergies","epi_pen","diabetes","head_injury",
  "medical_attention_for_head_injury","protective_or_corrective_equipment","injuries",
  "special_needs","diagnosed_concussion","other","special_requests","cardiac_health",
  "hospitalization","orthopedic","seizure_disorder","vision","preferred_hospital",
  "life_threatening_allergies","allergies_other","devices_or_proestheses",
  "orthotics_or_braces","protective_eyewear","glasses_contacts","devices_other",
  "family_premature_death","family_serious_heart_conditions","family_cardiac_issues",
  "family_unexplained_syncope","family_sickie_cell","family_asthma",
  "family_health_history_other","begun_period","regular_periods",
  "irregularities_with_period","pregnancy","missing_testicle","groin_problems",
  "head_injury_concussion_other", "medically_advised_not_to_participate",
  "surgery","exertional_syncope","exertional_chest_pain","fluttering",
  "cardiac_diagnostic_tests", "exertional_shortness_of_breath","exertion_headaches",
  'unexplained_seizures','excessive_shortness_of_breath', "exertional_dizziness",
  "down_syndrome_or_dwarfism",'painful_joints','juvenile_arthritis','exertional_wheezing',
  "asthma_medication","missing_organs",'single_kidney','mononucleosis','skin_problems',
  'skin_infections','heat_illness', "exertional_muscle_cramps","hearing_issues",
  "stomach_issues","weight_concerns",'weight_recommendations','eating_disorders',
  "hematologic_disorders","health_medical_other","injury_resulting_in_loss_of_play",
  'breaks_fractures_dislocations', "orthopedic_diagnostic_tests_or_treatment",
  "stress_fractures",'current_injury','post_impact_numbness','eye_injuries',
  "spine_injuries","injuries_other",'academic_behavioral_other',
  'academic_accommodations','retained','exposure','symptoms','covid_positive',
  'covid_symptomatic','covid_healthcare_assistance','covid_cardiac_symptoms',
  'covid_hospitalization','mis_c','communicable_diseases_other', 'hearing_aid',
  'anaphylaxis', 'migraines', 'family_heart_abnormalities'
])
const SELECTS = new Set([
  "relationship", "state", "country_id", "gender", "citizenship_id",
  "t_shirt_size_id", "height_inches", "weight_pounds", "grade"
])

export default{
  data: ()=>({
    component: null
  }),
  created(){
    const attr = this.$attrs.attr
    if (attr === 'birth_date' || attr === 'physical_date'){
      this.loadComponent('date_select')
    }else if (attr === 'custodial' || attr === 'may_pickup'){
      this.loadComponent('radio')
    }else if (attr.endsWith('_phone')){
      if (attr === "cell_phone") {
        this.loadComponent('cell_phone_number')
      } else {
        this.loadComponent('phone_number')
      }
    }else if (SELECTS.has(attr)){
      this.loadComponent('select')
    }else if (attr === 'dosage_and_time_instructions' || PersonConcern__FIELDS.has(attr)){
      this.loadComponent('textarea')
    }else{
      this.loadComponent('text')
    }

  },
  methods: {
    loadComponent(comp){
      import(`./standard_field/${comp}.vue`).then(res=> this.component=res.default )
    },
  },
}
</script>
